export const ACCOUNTS_SERVICE = 'accounts';
export const ACCOUNTS_SERVICE_API_VERSION = 'v1';

export const BASE_SERVICE = 'base';
export const BASE_SERVICE_API_VERSION = 'v1';

export const INSTITUTE_SERVICE = 'institutes';
export const INSTITUTE_SERVICE_API_VERSION = 'v1';
